import React from 'react'
import { Grid, Stack } from '@mui/material'
import DaysCheckboxList from '../DaysCheckboxList/DaysCheckboxList'
import AddComment from '../../../shared/UI/AddComment/AddComment'
import ReviewerComments from '../../../shared/UI/AddComment/ReviewerComments'
import ActionButtons from '../../../shared/UI/ActionButtons/ActionButtons'
import { EnhancementDay } from '../../../models/enhancement'
import Drawer from '../../../shared/UI/Drawer'

interface ApprovalDrawerProps {
  open: boolean
  onClose: (drawerOpen: boolean) => void
  requestedDays: EnhancementDay[]
  handleDaysChange: (updatedDays: EnhancementDay[]) => void
  comments: string
  setComments: (comments: string) => void
  commentsError: boolean
  isReadOnlyRequest: boolean
  declineDisabled: boolean
  isButtonDisabled: () => boolean
  approveWithChangesLoading: boolean
  displayClashModal: () => void
  approveRequest: () => void
  onApproveWithChanges: () => void
  showReviewerComments: boolean
  setShowReviewerComments: (show: boolean) => void
  fieldsTouched: any
  setFieldsTouched: (fields: any) => void
  hasChanges: () => boolean
  employeeLocationId?: number
  employeeLocationGroupId?: number
}

const ApprovalDrawer: React.FC<ApprovalDrawerProps> = function ({
  open,
  onClose,
  requestedDays,
  handleDaysChange,
  comments,
  setComments,
  commentsError,
  isReadOnlyRequest,
  declineDisabled,
  isButtonDisabled,
  approveWithChangesLoading,
  displayClashModal,
  approveRequest,
  onApproveWithChanges,
  showReviewerComments,
  setShowReviewerComments,
  fieldsTouched,
  setFieldsTouched,
  hasChanges,
  employeeLocationId,
  employeeLocationGroupId,
}) {
  const handleAddCommentClick = () => {
    setShowReviewerComments(!showReviewerComments)
  }

  return (
    <Drawer isOpen={open} onClose={onClose} narrow title="All days">
      <Grid container spacing={4} sx={{ padding: 2 }}>
        <Grid item xs={12} sx={{ overflowY: 'auto', maxHeight: 'calc(100vh - 100px)' }}>
          <DaysCheckboxList
            days={requestedDays}
            disableCheckbox={isReadOnlyRequest}
            disableTextField={isReadOnlyRequest}
            onDaysChange={handleDaysChange}
            error={day => day.checked && (!day.hours || day.hours === 0)}
            employeeLocationId={employeeLocationId}
            employeeLocationGroupId={employeeLocationGroupId}
          />
        </Grid>
        <Grid item xs={12}>
          <AddComment onClick={handleAddCommentClick} />
          <Stack direction="row">
            {showReviewerComments && (
              <ReviewerComments
                reviewerComments={comments}
                onBlur={() => setFieldsTouched({ ...fieldsTouched, reviewerComments: true })}
                onChange={e => setComments(e.target.value)}
                error={commentsError}
                disabled={isReadOnlyRequest}
              />
            )}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <ActionButtons
            declineDisabled={declineDisabled}
            submitDisabled={isButtonDisabled()}
            approveLoading={approveWithChangesLoading}
            onDecline={displayClashModal}
            onApprove={approveRequest}
            hasChanges={hasChanges()}
            showRejectButton={false}
            onApproveWithChanges={onApproveWithChanges}
            declineLabel="Decline"
          />
        </Grid>
      </Grid>
    </Drawer>
  )
}

export default ApprovalDrawer
